import { render, staticRenderFns } from "./wbjhList.vue?vue&type=template&id=104db214&scoped=true&"
import script from "./wbjhList.vue?vue&type=script&lang=js&"
export * from "./wbjhList.vue?vue&type=script&lang=js&"
import style0 from "./wbjhList.vue?vue&type=style&index=0&id=104db214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104db214",
  null
  
)

export default component.exports